import { CoursePickerModalController } from './course-picker-modal.controller';
import { CoursePickerModalProps } from './course-picker-modal.model';

export const CoursePickerModal = (props: CoursePickerModalProps) => {
  return <CoursePickerModalController {...props} />;
};
